<template>
	<a href="" @click.prevent="$emit('close')" class="close" :class="classList">
		<svg v-if="!isAndroid" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				class="path"
				opacity="0.8"
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M0.883939 0.530179C0.395784 1.01833 0.395783 1.80979 0.883939 2.29795L4.59631 6.01031L0.884027 9.7226C0.395871 10.2108 0.395871 11.0022 0.884027 11.4904C1.37218 11.9785 2.16364 11.9785 2.65179 11.4904L6.36407 7.77808L9.72277 11.1368C10.2109 11.6249 11.0024 11.6249 11.4905 11.1368C11.9787 10.6486 11.9787 9.85717 11.4905 9.36901L8.13184 6.01031L11.4906 2.65153C11.9788 2.16337 11.9788 1.37192 11.4906 0.883761C11.0025 0.395606 10.211 0.395606 9.72286 0.883761L6.36407 4.24255L2.65171 0.530179C2.16355 0.0420237 1.37209 0.0420237 0.883939 0.530179Z"
			/>
		</svg>

		<svg v-else viewBox="0 0 50 50" fill="none">
			<path
				class="path"
				d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"
			></path>
		</svg>
	</a>
</template>

<script>
import useApi from '@/composition/api.js'
import { computed } from '@vue/reactivity'

const CLOSE_POSITIONS = ['left', 'right']
const CLOSE_THEMES = ['dark', 'light', 'dark-invert', 'white', 'white-invert']

export default {
	emits: ['close'],

	props: {
		theme: {
			type: String,
			default: 'dark',
			validator: (val) => CLOSE_THEMES.includes(val)
		},
		position: {
			type: String,
			default: 'right',
			validator: (val) => CLOSE_POSITIONS.includes(val)
		}
	},

	setup(props) {
		const api = useApi()
		const platform = api.getPlatform()
		const isAndroid = platform == 'android'

		const classList = computed(() => {
			const array = [props.theme, props.position]

			if (isAndroid) {
				array.push('large', 'transparent')
			}
			return array
		})

		return {
			isAndroid,
			classList
		}
	}
}
</script>

<style lang="scss" scoped>
.close {
	position: absolute;

	top: 15px;
	width: 1.9rem;
	height: 1.9rem;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	text-decoration: none;
	z-index: 1;

	&.dark {
		background-color: rgba(255, 255, 255, 0.5);

		.path {
			fill: #828282;
		}
	}

	&.dark-invert {
		background: rgba(50, 54, 83, 0.5);

		.path {
			fill: #ffffff;
		}
	}

	&.white-invert {
		background: rgba(255, 255, 255, 0.5) !important;

		svg {
			width: 0.7rem !important;
			height: 0.7rem !important;

			.path {
				fill: #000 !important;
			}
		}
	}

	&.white {
		background: #e9eaf2;

		.path {
			fill: #323653;
		}
	}

	&.light {
		background-color: rgba(255, 255, 255, 0.2);

		.path {
			fill: #ffffff;
		}
	}

	&.gray {
		background-color: rgba(255, 255, 255, 0);

		.path {
			fill: #828282;
			opacity: 0.4;
		}
	}

	&.black {
		background-color: rgba(255, 255, 255, 0.1);

		.path {
			fill: #999999;
			opacity: 0.8;
		}
	}

	&.right {
		right: 13px;
	}

	&.left {
		left: 13px;
	}

	svg {
		width: 0.76rem;
		height: 0.76rem;
		display: block;
	}

	&.large {
		svg {
			width: 1.6rem;
			height: 1.6rem;

			.path {
				opacity: 0.9;
			}
		}
	}

	&.transparent {
		background-color: transparent;
	}
}
</style>
